import React from "react";
import styled from "styled-components";
import { FaFacebook, FaYoutube, FaInstagram, FaTwitter } from "react-icons/fa";

export default function SocialLinks() {
  return (
    <>
      <Social class="social">
        <a className="link" href="https://www.facebook.com">
          Facebook <FaFacebook className="icon" style={{ color: "#1da0f0" }} />
        </a>
        <a className="link" href="https://www.youtube.com">
          Youtube <FaYoutube className="icon" style={{ color: "#F80000" }} />
        </a>
        <a className="link" href="https://www.instagram.com">
          Instagram{" "}
          <FaInstagram
            className="icon"
            style={{
              color: "rgb(229, 105, 105)",
              fontWeight: "600",
            }}
          />
        </a>
        <a className="link" href="https://www.twitter.com">
          Twitter
          <FaTwitter className="icon" style={{ color: "#4ECCE8" }} />
        </a>
      </Social>
    </>
  );
}
const Social = styled.div`
  position: fixed;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transform: translate(-740px, 0);
  z-index: 87;
  .link {
    color: #fff;
    background: rgba(0, 0, 0, 0.4);
    font-size: 20px;
    font-weight: 600;
    text-decoration: none;
    display: block;
    margin: 5px;
    padding: 20px;
    width: 240px;
    text-align: right;
    border-radius: 50px;
    transition: 1s;
    transition-property: transform;
    &:hover {
      transform: translate(140px, 0);
    }
  }
  .icon {
    margin-left: 10px;
    font-size: 30px;
    width: 30px;
    height: 30px;
  }
`;
